// src/pages/admin/Configuration.js
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import AdminLayout from "../../layout/AdminLayout";
import { TbTruck, TbSettings, TbCoin, TbMapPin } from "react-icons/tb";
import VehicleTypes from "./VehicleTypesTab";
import MobileLocations from "./MobileLocationTab";
import Pricing from "./VehiclePricingsTab";
import DefaultPricing from "./DefaultPricingTab";

const tabContentVariants = {
  initial: {
    opacity: 0,
    y: 10,
  },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: "easeInOut",
    },
  },
  exit: {
    opacity: 0,
    y: -10,
    transition: {
      duration: 0.2,
      ease: "easeInOut",
    },
  },
};

const underlineVariants = {
  initial: {
    width: 0,
  },
  enter: {
    width: "100%",
    transition: {
      duration: 0.3,
      ease: "easeInOut",
    },
  },
};

const Configuration = () => {
  const [activeTab, setActiveTab] = useState("vehicleTypes");

  const tabs = [
    {
      id: "vehicleTypes",
      name: "Vehicle Types",
      icon: <TbTruck className="mr-2" />,
      component: <VehicleTypes />,
    },
    {
      id: "mobileLocations",
      name: "Locations",
      icon: <TbMapPin className="mr-2" />,
      component: <MobileLocations />,
    },
    {
      id: "pricing",
      name: "Mobile Locations Pricing",
      icon: <TbCoin className="mr-2" />,
      component: <Pricing />,
    },
    {
      id: "systemSettings",
      name: "System Settings",
      icon: <TbSettings className="mr-2" />,
      component: <DefaultPricing />,
    },
  ];

  return (
    <AdminLayout title="Configuration">
      <div className="px-2 sm:px-4 lg:px-8">
        {/* Tabs Navigation */}
        <div className="border-b border-gray-200 overflow-x-auto no-scrollbar">
          <nav className="flex space-x-4 sm:space-x-6 md:space-x-8 relative">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`relative whitespace-nowrap py-4 px-1 font-medium text-base flex items-center ${
                  activeTab === tab.id
                    ? "text-black"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                {tab.icon}
                {tab.name}
                {activeTab === tab.id && (
                  <motion.div
                    className="absolute bottom-0 left-0 h-0.5 bg-yellow-500"
                    variants={underlineVariants}
                    initial="initial"
                    animate="enter"
                  />
                )}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content with Animation */}
        <div className="py-4 relative">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              variants={tabContentVariants}
              initial="initial"
              animate="enter"
              exit="exit"
            >
              {tabs.find((tab) => tab.id === activeTab)?.component || (
                <div className="text-center py-8 text-gray-500">
                  Content coming soon
                </div>
              )}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Configuration;
